import round from "lodash/round";

export const centsToEuro = (cents: number) => cents / 100;
export const euroToCents = (euro: number) => round(euro * 100);

export const parseInputNumberValue = (num: string) => Number.parseFloat(num.replace(",", "."));

export const percentageOfTotal = (
  value?: number,
  total?: number,
  options: { rounded?: boolean } = { rounded: true },
) => {
  if (!value || !total) {
    return 0;
  }

  const percent = (value * 100) / total;

  return options.rounded ? round(percent) : percent;
};

export const marginPercentOfCost = (
  marginPrice?: number,
  cost?: number,
  options: { rounded?: boolean } = { rounded: true },
) => {
  if (!marginPrice || !cost) {
    return 0;
  }

  const percent = ((marginPrice - cost) / cost) * 100;

  return options.rounded ? round(percent) : percent;
};
